<div [class.collapsed]="isCollapsed$ | async" [style.height]="(isCollapsed$ | async) ? maxHeight+'px' : 'auto'">
  <ng-content></ng-content>
</div>
<button mat-button *ngIf="isCollapsable$ | async" (click)="toggleCollapse()" color="" class="align-self-end">
  {{(isCollapsed$ | async) ? 'More' : 'Collapse'}}
  <mat-icon>read_more</mat-icon>
</button>